import { Button, type ButtonProps } from "@teamworksdev/react";
import { type ChangeEvent, forwardRef, useImperativeHandle, useRef } from "react";

export type FileButtonRef = {
  clear: () => void;
};

type FileButtonProps = Omit<ButtonProps, "onClick" | "onChange"> & {
  onChange?: (files: FileList | null, e: ChangeEvent<HTMLInputElement>) => void;
  accept?: string;
};

export const FileButton = forwardRef<FileButtonRef, FileButtonProps>(({ accept, onChange, ...props }, ref) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    inputRef.current?.click();
  };

  useImperativeHandle(
    ref,
    () => ({
      clear: () => {
        if (inputRef.current) {
          inputRef.current.value = "";
        }
      },
    }),
    [],
  );

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => onChange?.(e.target.files, e);

  return (
    <label htmlFor="upload" className="relative">
      {/** biome-ignore lint/correctness/useUniqueElementIds: TODO: Use a unique id with useId() */}
      <input className="sr-only" id="upload" type="file" ref={inputRef} onChange={handleFileChange} accept={accept} />
      <Button {...props} onClick={handleClick} />
    </label>
  );
});

FileButton.displayName = "FileButton";
